/*
import { Product } from "../types/product";

export default function ProductCard({ product }: { product: Product }) {
  return (
    <div className="col-md-4 col-lg-3 mb-4">
      <article className="card h-100 shadow-sm">
        <div className="card-body">
          <h2 className="h6">{product.name}</h2>
          <p className="text-muted">{product.brand}</p>
          <p>Age: {product.min_age}–{product.max_age}</p>
          <strong>{product.price} ETB</strong>
        </div>
      </article>
    </div>
  );
}
*/
/*
import { Product } from "../types/product";
import { SaleItem } from "../types/sale";
import api from "../services/api";

import OIP from "../assets/OIP.jfif";
import OIP2 from "../assets/OIP2.jfif";
import OIP3 from "../assets/OIP3.jfif";
import OIP4 from "../assets/OIP4.jfif";

const productImages = [OIP, OIP2, OIP3, OIP4];

interface ProductCardProps {
  product: Product;
  onBuy: (item: SaleItem) => void;
}

export default function ProductCard({ product, onBuy }: ProductCardProps) {
  // Randomize every render
  const randomImage = productImages[Math.floor(Math.random() * productImages.length)];

  return (
    <article
      className="card h-100 border-0 shadow-sm transition-card"
      style={{ cursor: "pointer" }}
    >
      <div className="position-relative overflow-hidden">
        <img
          src={randomImage}
          alt={product.name}
          className="card-img-top img-fluid transition-img animate__animated animate__fadeIn"
          style={{ objectFit: "cover", height: "200px" }}
        />
        <span className="badge bg-success position-absolute top-0 end-0 m-2 animate__animated animate__bounceIn">
          {product.price} ETB
        </span>
      </div>

      <div className="card-body d-flex flex-column">
        <h5 className="card-title animate__animated animate__fadeInUp">{product.name}</h5>
        <p className="text-muted mb-2">{product.brand}</p>
        <p className="small mb-3">
          Age: {product.min_age}–{product.max_age}
        </p>

        <button
          className="btn btn-primary mt-auto w-100 transition-btn animate__animated animate__pulse"
          onClick={() => {
            onBuy({
              product_id: product.id,
              name: product.name,
              price: product.price,
              quantity: 1,
            });
          }}
        >
          Buy
        </button>
      </div>
    </article>
  );
}
*/
// src/components/ProductCard.tsx
// src/components/ProductCard.tsx
// src/components/ProductCard.tsx
// src/components/ProductCard.tsx
import { Product } from "../types/product";
import { SaleItem } from "../types/sale";
import OIP from "../assets/OIP.jfif";
import OIP2 from "../assets/OIP2.jfif";
import OIP3 from "../assets/OIP3.jfif";
import OIP4 from "../assets/OIP4.jfif";

const productImages = [OIP, OIP2, OIP3, OIP4];

interface ProductCardProps {
  product: Product;
  onBuy: (item: SaleItem) => void;
  onQuickView?: (product: Product) => void;
}

export default function ProductCard({ product, onBuy, onQuickView }: ProductCardProps) {
  const randomImage = productImages[Math.floor(Math.random() * productImages.length)];

  return (
    <article className="card h-100 border-0 shadow-sm transition-card">
      <div className="position-relative overflow-hidden">
        <img
          src={randomImage}
          alt={product.name}
          className="card-img-top img-fluid transition-img"
          style={{ objectFit: "cover", height: "200px" }}
        />

        {/* Price badge */}
        <span className="badge bg-success position-absolute top-0 end-0 m-2">
          {product.price} ETB
        </span>

        {/* Discount badge */}
        {product.discount && (
          <span className="badge bg-danger position-absolute top-0 start-0 m-2">
            -{product.discount}%
          </span>
        )}

        {/* Stock badge */}
        {product.stock !== undefined && product.stock <= 5 && (
          <span className="badge bg-warning position-absolute bottom-0 start-0 m-2">
            Low Stock
          </span>
        )}

        {/* ✅ Quick View hover overlay */}
        {onQuickView && (
          <div
            className="overlay d-flex align-items-center justify-content-center"
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0,0,0,0.4)",
              opacity: 0,
              transition: "opacity 0.3s",
            }}
            onClick={() => onQuickView(product)}
          >
            <span
              className="btn btn-light rounded-circle"
              style={{ fontSize: "1.2rem" }}
            >
              🔍
            </span>
          </div>
        )}
      </div>

      <div className="card-body d-flex flex-column">
        <h5 className="card-title">{product.name}</h5>
        <p className="text-muted mb-2">{product.brand}</p>
        <p className="small mb-3">
          Age: {product.min_age}–{product.max_age}
        </p>

        <button
          className="btn btn-primary mt-auto w-100"
          onClick={() =>
            onBuy({
              product_id: product.id,
              name: product.name,
              price: product.price,
              quantity: 1,
            })
          }
        >
          Buy
        </button>
      </div>

      {/* CSS for hover effect */}
      <style>
        {`
          .card:hover .overlay {
            opacity: 1;
            cursor: pointer;
          }
        `}
      </style>
    </article>
  );
}



